import { ParentSize } from '@visx/responsive'
import React from 'react'
import styled from 'styled-components'

//------------------------------------------------------------------------------

const ErrorMessageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ErrorMessage = styled.div`
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
`

const SmallErrorMessage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  align-content: center;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 0.9;
`

//------------------------------------------------------------------------------

/**
 * An error message view, used when we're unable to render a unit
 * @param props information about the unit we can't display
 */
export const ErrorView: React.FunctionComponent<{
  error: Error
}> = ({ error }) => (
  <ParentSize>
    {({ width }) =>
      width < 300 ? (
        <ErrorMessageContainer>
          <SmallErrorMessage>
            <small>{error.message}</small>
          </SmallErrorMessage>
        </ErrorMessageContainer>
      ) : (
        <ErrorMessageContainer>
          <ErrorMessage>
            <h1>Unable to display Asset</h1>
            <h3>Error: {error.message}</h3>
          </ErrorMessage>
        </ErrorMessageContainer>
      )
    }
  </ParentSize>
)
